module.exports = __webpack_public_path__ + "media/images/rahnu-1e951fa795a3b8b1d6600352a16906ae.svg";